/**
 * ConnectionRowsSkeleton — placeholder people rows for the connections tabs.
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../../components/ui/Skeleton';
import './connections.css';

interface ConnectionRowsSkeletonProps {
  count?: number;
}

export function ConnectionRowsSkeleton({ count = 6 }: ConnectionRowsSkeletonProps) {
  return (
    <SkeletonGroup className="connections-list">
      {skeletonKeys(count).map(key => (
        <div className="connection-row" key={key} aria-hidden>
          <Skeleton shape="circle" className="connections-skeleton__avatar" />
          <div className="connections-skeleton__meta">
            <Skeleton className="connections-skeleton__line" />
            <Skeleton className="connections-skeleton__line connections-skeleton__line--detail" />
          </div>
        </div>
      ))}
    </SkeletonGroup>
  );
}
